// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"596":"7d7c6240","787":"68e5b703"}[chunkId] + ".chunk.js";
};